module.exports = __webpack_public_path__ + "static/014.thumb-fc2079d8421cdba7fc053073cef7601e.jpg";